// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"855e1434","186":"fa169ca6","225":"30ef0662","344":"b1eba148","372":"d149ffa5","377":"e258eac8","630":"ea761b42","738":"e9994470","841":"dacbfdb2","856":"982e9154"}[chunkId] + ".chunk.js";
};